import React, { FC, ReactElement } from 'react'
import { Button, ButtonGroup as MUIButtonGroup } from '@material-ui/core'
import { ButtonGroupEntry } from './Types'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

type Props = {
    className?: string
    name: string
    entries: ButtonGroupEntry[]
    isRouterMode?: boolean
}

export const ButtonGroup: FC<Props> = ({ className, name, entries, isRouterMode }: Props): ReactElement => (
    <MUIButtonGroup
        className={`button-group ${className} ${isRouterMode ? 'router-button-group' : EMPTY_STRING}`}
        variant='contained'
    >
        {entries.map(
            (
                { buttonClassName, onClick, isActive, content, buttonRef, isEnabled = true }: ButtonGroupEntry,
                index: number
            ): ReactElement => (
                <Button
                    key={`button-group-${name}-entry-${index}`}
                    className={`button-group-entry ${isActive ? 'button-active' : EMPTY_STRING} ${buttonClassName}`}
                    onClick={onClick}
                    ref={buttonRef}
                    disabled={!isEnabled}
                >
                    {content}
                </Button>
            )
        )}
    </MUIButtonGroup>
)
